export default __webpack_public_path__ + "static/media/service.066dc421.svg";